import type { AddLineItemType } from "@/Shared/Types/lineItemTypes";
import type { LineItem } from "@freightsimple/generated-dashboard-openapi-client/models/LineItem";

export function totalWeightForLineItems(
  lineItems: Array<LineItem | AddLineItemType>,
): number | undefined {
  let totalWeight = 0;

  for (const lineItem of lineItems) {
    if (lineItem.weightPerHandlingUnit === undefined) {
      return undefined;
    }

    totalWeight +=
      lineItem.weightPerHandlingUnit * lineItem.numberHandlingUnits;
  }

  return totalWeight;
}

export function totalHandlingUnitsForLineItems(
  lineItems: Array<LineItem | AddLineItemType>,
): number {
  let totalNumberHandlingUnits = 0;

  for (const lineItem of lineItems) {
    totalNumberHandlingUnits += lineItem.numberHandlingUnits;
  }

  return totalNumberHandlingUnits;
}

export function totalWeightForLineItem(
  lineItem: LineItem | AddLineItemType,
): number | undefined {
  if (lineItem.weightPerHandlingUnit === undefined) {
    return undefined;
  }

  return lineItem.weightPerHandlingUnit * lineItem.numberHandlingUnits;
}
